import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { SignoffLoopScreen } from "../components/family-signoffs/SignoffLoopScreen";

export function createFamilySignoffsScreens(): FlowScreenConfig[] {
  return [
    {
      id: "family_signoff_loop",
      layout: "full",
      hideButton: true,
      customComponent: SignoffLoopScreen,
    },
  ];
}
